module.exports = "/images/pillInnerRing.png?ccfef64ccdaa456ee11ac575539ac503";